import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
let lenisInstance = null;
export function initSmoothScroll() {
    if (lenisInstance) return lenisInstance;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return null;
    const lenis = new Lenis({
        duration: 1.15,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true, smoothTouch: false,
    });
    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add((time) => lenis.raf(time * 1000));
    gsap.ticker.lagSmoothing(0);
    lenisInstance = lenis;
    return lenis;
}
export function destroySmoothScroll() {
    if (lenisInstance) { lenisInstance.destroy(); lenisInstance = null; }
}
